import { i18n } from '@/plugins/i18n';
import { getMavenUserData } from '@/api/maven';
import { useMainStore } from '@/stores/mainStore';
import { useUserStore } from '@/stores/userStore';

declare global {
  interface Window {
    Maven?: {
      ChatWidget: {
        load: (options: Record<string, any>) => void;
        show: () => void;
        open: () => void;
        close: () => void;
        hide: () => void;
      };
    };
  }
}

const { t } = i18n.global;

function initMaven() {
  const script = document.createElement('script');
  script.id = 'influencer-maven-chat-widget';
  script.src = 'https://chat.onmaven.app/js/widget.js';
  script.defer = true;
  document.head.appendChild(script);
}

async function loadMaven() {
  const userStore = useUserStore();
  const mavenUserData = await getMavenUserData();

  window.Maven?.ChatWidget.load({
    organizationId: 'teamworks',
    agentId: 'support',
    bgColor: userStore.axleProfile?.navbarBottomColor ?? '#EAA934',
    buttonLabel: t('navigationMenu.getHelp'),
    hideButton: true,
    signedUserData: mavenUserData.jwt,
    tags: ['gm'],
    showPoweredBy: false,
  });
}

async function toggleMaven() {
  const mainStore = useMainStore();

  if (mainStore.isMavenChatOpen) {
    window.Maven?.ChatWidget.close();
    window.Maven?.ChatWidget.hide();
  } else {
    await loadMaven();
    window.Maven?.ChatWidget.show();
    window.Maven?.ChatWidget.open();
  }

  mainStore.toggleMavenChat();
}

export { initMaven, toggleMaven };
